import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import VUSeal from './VUSeal'
import { supabase } from '../supabaseClient'
import './AuthPage.css'

export default function UpdatePassword() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      const { error } = await supabase.auth.updateUser({ password })
      if (error) throw error
      navigate('/dashboard')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-seal"><VUSeal size={120} /></div>
        <h1 className="auth-title">Set new password</h1>
        <p className="auth-sub">Enter your new password below.</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="auth-lbl">New password</label>
            <input className="auth-input" type="password" placeholder="At least 8 characters" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} />
          </div>
          {error && <p className="auth-error">{error}</p>}
          <button className="auth-submit" type="submit" disabled={loading}>{loading ? 'Updating...' : 'Update password'}</button>
        </form>
      </div>
    </div>
  )
}
